import svgI from './index.vue';

svgI.install = (vue) => {
  vue.component(svgI.name, svgI);
};

export default svgI;
